import React from "react";
import { Grid, Card,  Container, Typography, Stack} from '@mui/material';
import FormManager from "../../../components/formComponents/FormManager";
import schema from './schema.json';
import HTTPManager from "../../../utils/httpRequestManager";
import TableView from '../../../components/table/tableView';
import { toast, ToastContainer } from 'react-toastify';
import FButton from '../../../components/formComponents/components/button';
import Page from '../../../components/Page';
import Loader from '../../../components/Loader';
// import Iconify from '../../../components/Iconify';
import { checkButtonAccess } from "../../../utils/protector";

// const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

export default class Region extends React.Component{
    httpManager = new HTTPManager();

    constructor(){
        super();
        this.state={
            schema:{},
            statesList:[],
            addForm: false,
            isLoading: false, 
            columns:[ 
                {
                    field: 'code',
                    headerName: 'State Code',
                    maxWidth: 200,
                    flex:1,
                    editable: false,
                    renderCell: (params) => (
                        <div>
                            {params.row.stateCode === '' || params.row.stateCode === null? '--': params.row.stateCode}
                        </div>
                    )
                }, 
                {
                    field: 'name',
                    headerName: 'State Name',
                    maxWidth: 200,
                    flex:1,
                    editable: false,
                    renderCell: (params) => (
                        <div>
                            {params.row.stateName === '' || params.row.stateName === null? '--': params.row.stateName}
                        </div>
                    )
                }, 
                {
                field: 'Action',
                headerName:'Actions',
                minWidth:150,
                flex:1,
                renderCell: (params) => (
                    <strong>  
                        {params.row.isDefault !== '1' && checkButtonAccess('Region') === 'W' &&
                            <FButton permission_id = "web_edit_region" permission_label="Show edit region"
                            variant="outlined" 
                            size="small" 
                            onClick={()=>this.openEdit(params.row)} 
                            label="Edit"/>
                        }   
                    </strong>
                    
                ),
                },
            ]
        }

        this.reloadData = this.reloadData.bind(this); 
    }
 
    updateRecord(row, status){
        this.setState({isLoading: true}, ()=>{
            this.httpManager.postRequest(`region/updateRegion`, {regionStatus: status, id: row.id}).then(res=>{
                //console.log(res.message);
                this.setState({isLoading: false});
                this.reloadData(res.message);
            })
        })
    } 
    componentDidMount(){ 
        this.setState({schema: schema},()=>{

        });
        this.reloadData();
    }
 

    openEdit(data){
        //console.log(data) 
        var propslist = Object.assign([], this.state.schema.properties);
       
        var props=[];
        propslist.forEach((field,i)=>{
            field.value = data[field.name];
            props.push(field);
            if(i === propslist.length-1){
                props.push({
                    "component":"TextField", 
                    "type": "hidden", 
                    "minLength": 1,
                    "maxLength": 50,
                    "grid":6,
                    "name":"id",
                    "label":"id",
                    "placeholder":"id",
                    "value":data.id
                  })
                schema.properties = props; 
                this.setState({schema: schema},()=>{
                    this.setState({addForm: true})
                })
            }
        })
    }

    reloadData(msg=''){
        if(msg !== ''){ 
            toast.dismiss();
            toast.success(msg, {
                position: "top-center",
                autoClose: 5000,
                closeButton:false,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
        this.setState({isLoading: true, addForm: false},()=>{
            this.httpManager.getRequest(`lookup/getStates`).then(response=>{
                //console.log(response)
                this.setState({statesList: response.data, isLoading: false});
            })
        })
    } 

    handleCloseform(msg){
        this.setState({addForm:false})
    }

    render(){
        return <Page title="States | Astro POS">
        {this.state.isLoading && <Loader show={this.state.isLoading} />}
            <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss={false}
            draggable={false}
            pauseOnHover={false}
            />

{!this.state.addForm ? 
        <Container maxWidth="xl">
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              State Management
            </Typography> 
          </Stack>

          <Card>
              <TableView 
                permission_id = "web_view_region" 
                permission_label="Show view region"
                data={this.state.statesList} 
                columns={this.state.columns} />
          </Card>
        </Container> : ''
        }
        {this.state.addForm && 
            <Container maxWidth="xl">
               
                <Grid container spacing={3}  alignItems="center"  justifyContent="center" style={{marginLeft:0, marginRight:0,width:'100%', fontWeight:'bold'}} > 
                    {/* <Grid item xs={1}></Grid> */}
                    <Grid item xs={12}> 
                        <Stack spacing={3}> 
                            <FormManager formProps={this.state.schema} formFunctions={{
                                onStateChange: this.onStateChange,
                                onstateNameChange: this.onstateNameChange
                            }}  reloadData={()=>this.reloadData()} closeForm={()=>this.handleCloseform()}/>
                        </Stack>
                    </Grid>
                    {/* <Grid item xs={1}></Grid>  */}
                </Grid>
              
            </Container>
        }
        </Page>
    }
}